import {paymentCmdService, paymentQueryService} from '../index'

class Plans {
    getPlans = () => paymentQueryService.get('plans')
    getSubscriptions = () => paymentQueryService.get('subscriptions')
    getSubscriptionPayments = id => paymentQueryService.get(`subscription/${id}/payments`)
    deleteSubscription = id => paymentCmdService.delete(`subscription/${id}`)
    reactivateSubscription = id => paymentCmdService.put(`subscription/${id}`)
    createSession = data => paymentCmdService.post('session', data)
    updateSubscription = (id, data) => paymentCmdService.patch(`subscription/${id}`, data)
    createSubscriptionSession = id => paymentCmdService.post(`subscription/${id}/session`)
    getPaymentMethods = () => paymentQueryService.get('payment-methods')
    getProration = (id, productId) => paymentQueryService.get(`subscription/${id}/proration/${productId}`)
    getCoupon = code => paymentQueryService.get(`coupon/${code}`)
}

export default new Plans()
